var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v(" "+_vm._s(_vm.cardHeader)+" ")]),_c('div',{staticClass:"col col-auto close-button",on:{"click":function($event){return _vm.$emit('clear')}}},[_c('i',{staticClass:"fa fa-times"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }